import React, { useEffect, useRef, useState } from "react";
import SectionHeader from "../Common/SectionHeader/SectionHeader";
import HeadsetMicOutlinedIcon from '@mui/icons-material/HeadsetMicOutlined';
import "./ContainerLayoutStyle.scss";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

function ContainerLayout({
  stepNo,
  totalSteps,
  children,
  bgImage,
  backTo,
  nestedChild,
  stepRoutes,
  showHeader = true,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const { planDetails } = location.state || {};
  const { i18n } = useTranslation();
  const { t } = useTranslation();
  const [helpOpen, setHelpOpen] = useState(false);
  const helpPopupRef = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (
        helpOpen &&
        helpPopupRef.current &&
        !helpPopupRef.current.contains(event.target)
      ) {
        setHelpOpen(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentClick);
    return () => document.removeEventListener("mousedown", handleDocumentClick);
  }, [helpOpen]);

  // const pickUserIdentity = (details = {}) => ({
  //   name: details.name,
  //   mobileNumber: details.mobileNumber,
  //   termsCondition: details.termsCondition
  // });

  const handleBack = () => {
    if (
      location.pathname === "/add-beneficiary" &&
      planDetails?.coverPlan === "Term plan"
    ) {
      navigate("/sum-assured", {
        state: { planDetails },
      });
    } else if (
      location.pathname === "/summary" &&
      planDetails?.coverPlan === "Term plan"
    ) {
      navigate("/question/life", {
        state: { planDetails },
      });
    } else if (backTo) {
      navigate(backTo, {
        state: { planDetails },
      });
    } else {
      window.history.back();
    }
  };

  // const buildDefaultStepRoutes = () => {
  //   const coverPlan = planDetails?.coverPlan;
  //   let step2 = "/plans/health/individual-medical";
  //   if (coverPlan === "Affordable Health Cover") {
  //     step2 = "/plans/health/affordable-health-cover-plan";
  //   } else if (coverPlan === "Unified Domestic Worker") {
  //     step2 = "/plans/health/unified-domestic-worker";
  //   }
  //   return [
  //     "/basic-information",
  //     step2,
  //     "/personal-information",
  //     "/question/health",
  //   ];
  // };

  // const handleStepClick = (targetStep) => {
  //   if (!stepNo || targetStep >= stepNo) return;
  //   const routes = Array.isArray(stepRoutes) && stepRoutes.length
  //     ? stepRoutes
  //     : buildDefaultStepRoutes();
  //   const targetPath = routes[targetStep - 1];
  //   if (targetPath) {
  //     navigate(targetPath, {
  //       state: { planDetails },
  //     });
  //   }
  // };

  return (
    <>
      <div
        className={i18n.dir() === "rtl" ? "rtl-layout" : "ltr-layout"}
        style={{ backgroundColor: "#f4f4f4ff", position: "relative" }}
      >
        {showHeader ? (
          <div className="life-contact-popup-wrapper" ref={helpPopupRef}>
            {helpOpen ? (
              <aside className="life-contact-popup" role="dialog" aria-label="Help contact details">
                <p className="life-contact-popup__label">Need help?</p>
                <p className="life-contact-popup__message">
                  Please contact <a href="tel:80007777">@8000 77 77</a>
                </p>
                <p className="life-contact-popup__hours">
                  Oman office time: Sun to Thu, 8:00 AM to 5:00 PM
                </p>
              </aside>
            ) : null}
            <button
              type="button"
              className="life-contact-popup-toggle"
              onClick={() => setHelpOpen((current) => !current)}
              aria-expanded={helpOpen}
              aria-label={helpOpen ? "Close help details" : "Open help details"}
            >
              <HeadsetMicOutlinedIcon fontSize="small" />
            </button>
          </div>
        ) : null}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#f4f4f4ff",
            // boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          }}
        >
          <div className="container-fluid pb-5">
            <div className="row">
              <div className="col-md-12">
                <SectionHeader
                  title={t("life insurance")}
                  stepNo={stepNo}
                  totalStep={totalSteps}
                  onBack={handleBack}
                  showHeader={showHeader}
                  // onStepClick={handleStepClick}
                />
              </div>
            </div>
            <div className="container bg-white mt-2">
              <div className="innerwrapper">
                <div className="container">{children}</div>
                {nestedChild ? (
                  <div className="col-md-6">{nestedChild}</div>
                ) : (
                  <div className="col-md-7 p-0 mt-2 d-flex justify-content-center align-items-center">
                    <div className={bgImage}></div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ContainerLayout;
